export default __webpack_public_path__ + "static/media/ic_sun.4233a518.svg";